<template>
    <div class="my_header">
        <div class="layout">
            <h1 class="my_header_logo">
                智慧理工
            </h1>
            <ul class="my_header_nav">
                <li ><a href="https://zhlg.hpu.edu.cn/">首页</a></li>
                <li ><a href="https://zhlg.hpu.edu.cn/portal/app">业务系统中心</a></li>
                <li :class="{ active: true }">
                  <el-badge :value="todoNum" class="item">
                    <a href="javascript:;" @click="changeTab('/workflow/appall')">网上办事大厅</a>
                  </el-badge>
                </li>
                <li > <a href="https://zhlg.hpu.edu.cn/portal/personal" >个人数据中心</a></li>
            </ul>
            <p class="login_info">{{Name}},{{userPostion}}<a href="javascript:;"  @click="signOutOidc">退出</a></p>
        </div>
    </div>
</template>
<script>
export default {
  components: {
  },
  data() {
    return {
      userPostion:'',
      searchText: "",
      logoUrl: "",
      pageWords: {
        apps: "输入服务名称",
        appall: "输入服务名称",
        todo: "请输入待办事项相关的关键字",
        weituo: "请输入委托事项相关的关键字",
        doing: "请输入办理中事项相关的关键字",
        done: "请输入已完成事项相关的关键字",
        flow_cc: "请输入抄送事项相关的关键字",
      },
    };
  },
  inject: ["isPage", "routeName", "reload"],
  watch: {
    pageType: {
      handler(val, oldval) {
        if (val != oldval) {
          this.searchText = "";
          if (val === "appall") {
            if (this.$store.getters.getState.appQuery.seq) {
              this.searchText = this.$store.getters.getState.appQuery.seq;
            }
          }
        }
        if (oldval === "todo" || oldval === "weituo") {
          let key = oldval + "_seq";
          sessionStorage.setItem(key, "");
        }
      },
      deep: true,
    },
        getAuth: {
      handler(val, oldval) {
        if (val != oldval) {
          this.getPostion();
        }
      },
      deep: true
    },
  },
  methods: {
    // changeLocaleProvider(e) {
    //   console.log(e.target.value);
    //   localStorage.setItem("locale", e.target.value);
    // },
   getPostion() {
     let that =this;
     this.$axios.get(`${window.commonApi.INFOPLUS_URL}/me/positions`).then((res) => {
       if (res.data.errno === 0) {
         if (res.data.entities && res.data.entities.length > 0){
           let positionObj = res.data.entities.filter(item => (item.post.code == 'JZG' || item.post.code == 'BKS' || item.post.code == 'YJS'))
           that.userPostion = positionObj[0].post.name;
         }else {
           that.userPostion = '';
         }
       }
     }).catch((error) => {
       console.log(error); //请求失败返回的数据
     });
  },
    changeTab(url) {
      if (url !== "/workflow/todo") {
        sessionStorage.removeItem("todoBaner");
      } else {
        sessionStorage.setItem("todoBaner", true);
      }
      this.$router.push(url);
    },
    signOutOidc() {
      this.$store.dispatch("oidcStore/signOutOidc");
    },
    onSearch() {
      let val = this.searchText || "all";
      this.$store.dispatch("updateQuery", { seq: val });
      if (this.isPage("apps")) {
        this.$router.push({
          path: "/workflow/appall",
        });
      }
    },
  },
  computed: {
        todoNum(){
      let num = this.$store.getters.getDataLength.todo;
      return num;
    },
     getAuth() {
      return this.$store.getters.getAuth.access_token
    },
    pageType() {
      return this.routeName();
    },
    Name() {
      let user = this.$store.getters.getAuth.user;
      if (user) {
        let name = "";
        for (let i in user.name) {
          name = name + user.name[i];
        }
        return name;
      } else {
        return "";
      }
    },
  },
};
</script>
<style scoped>
 .el-badge  /deep/ .el-badge__content{
  border: none;
  background-color: #f5222d;
}
 @media only screen and (max-width: 676px) {
  .login_info{
    float: left;
    margin-left: 20px;
  }
   .my_header_nav{
     margin-left: 0;
   }
 }
 @media only screen and (max-width: 841px) {
  .my_header_logo{
    line-height: 40px;
  }
 }
</style>



// WEBPACK FOOTER //
// src/views/todoCenter/default/workflow/layout/PC/header.vue